"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        paddingBottom: 7
    }
};
//# sourceMappingURL=stage.item.style.js.map